var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1375_388)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 99,
    height: 99,
    rx: 15,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6561 70C33.7605 70 32.9769 69.6667 32.3052 69C31.6336 68.3333 31.2977 67.5556 31.2977 66.6667V47.8333C30.2529 46.9444 29.5625 45.8519 29.2267 44.5556C28.8909 43.2593 28.9282 41.963 29.3386 40.6667L31.7455 33.1667C32.044 32.1667 32.5664 31.3889 33.3128 30.8333C34.0591 30.2778 34.9173 30 35.8875 30H66.8409C67.8857 30 68.7999 30.287 69.5836 30.8611C70.3672 31.4352 70.9083 32.2037 71.2068 33.1667L73.6696 40.6667C74.0801 41.963 74.1081 43.2593 73.7536 44.5556C73.3991 45.8519 72.6994 46.9444 71.6546 47.8333V66.6667C71.6546 67.5556 71.3187 68.3333 70.6471 69C69.9754 69.6667 69.1917 70 68.2962 70H34.6561ZM56.5417 46.1111C57.6239 46.1111 58.5381 45.7593 59.2844 45.0556C60.0308 44.3519 60.3293 43.5 60.18 42.5L58.7807 33.3333H53.1833V42.5C53.1833 43.463 53.5005 44.3056 54.1349 45.0278C54.7692 45.75 55.5715 46.1111 56.5417 46.1111ZM46.0747 46.1111C47.1195 46.1111 48.0058 45.7593 48.7334 45.0556C49.4611 44.3519 49.8249 43.5 49.8249 42.5V33.3333H44.2276L42.8282 42.5C42.679 43.463 42.9402 44.3056 43.6119 45.0278C44.2836 45.75 45.1045 46.1111 46.0747 46.1111ZM35.8875 46.1111C36.7831 46.1111 37.5574 45.8056 38.2104 45.1944C38.8635 44.5833 39.2459 43.8333 39.3579 42.9444L40.8132 33.3333H35.2159L32.6411 41.4444C32.2679 42.5926 32.4172 43.6574 33.0889 44.6389C33.7605 45.6204 34.6934 46.1111 35.8875 46.1111ZM67.0648 46.1111C68.2589 46.1111 69.2011 45.6296 69.8914 44.6667C70.5818 43.7037 70.7403 42.6296 70.3672 41.4444L67.7924 33.3333H62.1951L63.6504 42.9444C63.7623 43.8333 64.1448 44.5833 64.7978 45.1944C65.4509 45.8056 66.2065 46.1111 67.0648 46.1111ZM34.6561 66.6667H68.2962V49.3889C68.3335 49.4259 68.2122 49.4444 67.9323 49.4444H67.0648C66.1319 49.4444 65.2456 49.25 64.406 48.8611C63.5664 48.4722 62.7361 47.8704 61.9152 47.0556C61.3181 47.7963 60.5718 48.3796 59.6763 48.8056C58.7807 49.2315 57.7918 49.4444 56.7097 49.4444C55.5902 49.4444 54.6293 49.287 53.827 48.9722C53.0247 48.6574 52.2504 48.1296 51.5041 47.3889C50.9444 48.0556 50.2354 48.5648 49.3771 48.9167C48.5189 49.2685 47.5487 49.4444 46.4665 49.4444C45.3097 49.4444 44.2836 49.2407 43.388 48.8333C42.4924 48.4259 41.7274 47.8333 41.0931 47.0556C40.1975 47.8333 39.3206 48.4259 38.4623 48.8333C37.6041 49.2407 36.7458 49.4444 35.8875 49.4444H35.1319C34.8893 49.4444 34.7307 49.4259 34.6561 49.3889V66.6667Z",
    fill: "#044535"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1375_388",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1375_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1375_388",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop100);
export default __webpack_public_path__ + "static/media/shop100.5ed517a595af819cf352d0d160cf5d07.svg";
export { ForwardRef as ReactComponent };